import { getHrBreakLineTemplate } from "../../shortcodes/templates";

const hrBreakLineConfig = {
  title: "Insert break line",
  body: {
    type: "panel",
    name: "hrLineValue",
    items: [
      {
        type: "colorinput",
        name: "color",
        label: "Color",
      },
      {
        type: "input",
        name: "width",
        placeholder: "100%",
        label: "Width",
      },
    ],
  },
  initialData: {
    color: "#E9E9E9",
  },
  buttons: [
    {
      type: "cancel",
      name: "closeButton",
      text: "Cancel",
    },
    {
      type: "submit",
      name: "submitButton",
      text: "Insert",
      primary: true,
    },
  ],
  onChange: function (api) {
    const IS_NUMBER_REGEX = /^-?\d*\.?\d*$/;

    if (api.getData().width !== "" && !IS_NUMBER_REGEX.test(api.getData().width)) {
      api.setData({ width: api.getData().width.substring(0, api.getData().width.length - 1) });
    }

    if (api.getData().width.length > 3) {
      api.setData({ width: api.getData().width.substring(0, api.getData().width.length - 1) });
    }

    if (Number(api.getData().width) > 100) {
      api.setData({ width: "100" });
    }
  },
  onSubmit: function (api) {
    let hrColor, hrWidth;
    hrColor = api.getData().color;

    if (api.getData().width === "") {
      hrWidth = "100%";
    } else {
      hrWidth = api.getData().width + "%";
    }

    // eslint-disable-next-line no-undef
    tinymce.activeEditor.execCommand("mceInsertContent", false, getHrBreakLineTemplate(hrColor, hrWidth));
    api.close();
  },
};

export { hrBreakLineConfig };
